
import { mapActions } from 'vuex'
import productData from '@/data/products.json'
import optionsData from '@/data/options.json';
export default {
    props: {
        id: {
            default: '',
            type: String,
        },
        course: {
            default: '120-hour Premier Online TEFL Course',
            type: String,
        },
        classroom: {
            default: 'false',
            type: String,
        },
        bundle: {
            default: 'false',
            type: String,
        },
        bulletone: {
            default: 'Are new to TEFL',
            type: String,
        },
        bullettwo: {
            default: 'Speak English fluently',
            type: String,
        },
        bulletthree: {
            default: 'Want to travel and teach English abroad',
            type: String,
        },
        bulletfour: {
            default: 'or earn money from home teaching online',
            type: String,
        },
        text: {
            default: 'Book Course Now',
            type: String
        },
        product_id: {
            default: null,
            type: String
        }
    },
    data(){
        return{
            // isVisible:false
            // product: {},
            // priceData: {},
            options: optionsData,
            // Set by the countdown's visibility emit — hides the promo bar and drops its spacer when there's no countdown
            countdownVisible: false
        }
    },
    computed:{
        // Page-level virtual variant. Only resolvable when this box is showing the
        // page's main product — if an explicit product_id prop is passed we can't
        // know its virtual sibling, so we skip it.
        virtualPid() {
            if (this.$props.product_id !== null) return null
            return this.$store.state.pages.page.virtualProductId || null
        },
        virtual_product() {
            const vid = this.virtualPid
            if (!vid) return {}
            const found = productData.find((o) => o.id.toString() === vid.toString())
            return found || {}
        },
        vpriceData() {
            if (this.virtual_product && Object.keys(this.virtual_product).length > 0) {
                return this.$options.filters.priceData(this.virtual_product)
            }
            return {}
        },
        // Headline the deeper of the two discounts when both variants exist
        headlinePriceData() {
            const base = this.priceData
            const virtual = this.vpriceData
            if (virtual && Object.keys(virtual).length > 0) {
                const basePct = this.$options.filters.discountPercentageFromLabel(base.pricesDiscounted) || 0
                const virtualPct = this.$options.filters.discountPercentageFromLabel(virtual.pricesDiscounted) || 0
                return virtualPct > basePct ? virtual : base
            }
            return base
        },
        hasBothVariants() {
            return this.vpriceData && Object.keys(this.vpriceData).length > 0
        },
        pid(){
            return this.$props.product_id === null ? this.$store.state.pages.page.productId : this.$props.product_id
        },
        rand(){
            return Math.floor(Math.random() * 100)
        },
        product(){
            return productData.find((o) => {
                return o.id.toString() === this.pid
            })
        },
        priceData(){
            return this.$options.filters.priceData(
                this.product,
            )
        },
        saleArray(){
          const FPCourses = optionsData.freeproduct_array ? JSON.parse(optionsData.freeproduct_array) : [];
          return FPCourses
        }

    },
    methods: {
        ...mapActions({
            addToCart:'cart/addToCartServer'
        })
    }
}
